import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { InfoOption } from '../../components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { wealthDistributionOptions } from '../../services/ref';

@Component({
    selector: 'wealth-distribution-form',
    templateUrl: './wealth-distribution-form.component.html',
    styleUrls: ['./wealth-distribution-form.component.scss'],
    standalone: false
})
export class WealthDistributionFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  options: FormControlOption[] = wealthDistributionOptions;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.selectErrorInputAndScroll(this);

    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
